import { Box, Card, Text, ActionIcon } from '@mantine/core'
import { calculateAge, formatDateTime, formatPatientName } from '@/utils.ts'
import { useState } from 'react'
import { useMedplum } from '@medplum/react'
import { IconUserEdit } from '@tabler/icons-react'
import CreateUpdatePatientModal from '@/components/ui/CreateUpdatePatientModal/CreateUpdatePatientModal'
import { Patient } from '@medplum/fhirtypes'
import { PhoneLink } from '@/components/ui/PhoneLink'

interface PatientDemographicsProps {
  patientData: Patient
  refetchPatientData: () => void
}

export const PatientDemographics = ({
  patientData,
  refetchPatientData,
}: PatientDemographicsProps) => {
  const medplum = useMedplum()
  const [isPatientModalOpen, setIsPatientModalOpen] = useState(false)
  return (
    <Box mr={50}>
      <Card
        radius="sm"
        p="sm"
        withBorder
        className="flex"
        style={{
          margin: '0 10',
          padding: '20',
          borderColor: 'rgba(34, 139, 230, 0.18)',
          background:
            'radial-gradient(1200px 600px at 20% -10%, rgba(34,139,230,0.14) 0%, transparent 55%),' +
            'radial-gradient(900px 500px at 110% 10%, rgba(99,102,241,0.10) 0%, transparent 55%),' +
            'linear-gradient(180deg, rgba(255,255,255,0.92) 0%, rgba(255,255,255,0.98) 100%)',
          boxShadow: '0 20px 45px rgba(0,0,0,0.08), 0 2px 10px rgba(0,0,0,0.05)',
        }}
      >
        <div className="mb-4 flex items-center justify-between">
          <Text>
            {formatPatientName(patientData.name?.[0])} ({calculateAge(patientData?.birthDate || '')}{' '}
            y.o.)
          </Text>
          <ActionIcon
            onClick={() => setIsPatientModalOpen(true)}
            variant="outline"
            className="ml-6"
          >
            <IconUserEdit size={16} />
          </ActionIcon>
        </div>
        <Text>DOB : {formatDateTime(patientData.birthDate || '', '-', false, true)}</Text>
        <Text>Gender : {patientData.gender}</Text>
        <Text>
          Phone :{' '}
          <PhoneLink
            phone={patientData.telecom?.find((t) => t.system === 'phone')?.value}
            fallback="N/A"
          />{' '}
          <br />
        </Text>
        <Text>
          Email : {patientData.telecom?.find((t) => t.system === 'email')?.value || 'N/A'} <br />
        </Text>
      </Card>
      <CreateUpdatePatientModal
        isOpen={isPatientModalOpen}
        onClose={() => setIsPatientModalOpen(false)}
        patient={patientData}
        successCallback={() => {
          medplum.invalidateSearches('Patient')
          refetchPatientData()
        }}
      />
    </Box>
  )
}
